/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Shortcuts_Mock_Group_OrdersInputs */

const tr_landing_shortcuts_mock_group_orders = /** @type {(inputs: Landing_Shortcuts_Mock_Group_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SİPARİŞLER`)
};

const en_landing_shortcuts_mock_group_orders = /** @type {(inputs: Landing_Shortcuts_Mock_Group_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ORDERS`)
};

const de_landing_shortcuts_mock_group_orders = /** @type {(inputs: Landing_Shortcuts_Mock_Group_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BESTELLUNGEN`)
};

const ru_landing_shortcuts_mock_group_orders = /** @type {(inputs: Landing_Shortcuts_Mock_Group_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ЗАКАЗЫ`)
};

/**
* | output |
* | --- |
* | "ORDERS" |
*
* @param {Landing_Shortcuts_Mock_Group_OrdersInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_shortcuts_mock_group_orders = /** @type {((inputs?: Landing_Shortcuts_Mock_Group_OrdersInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Shortcuts_Mock_Group_OrdersInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_shortcuts_mock_group_orders(inputs)
	if (locale === "de") return de_landing_shortcuts_mock_group_orders(inputs)
	if (locale === "ru") return ru_landing_shortcuts_mock_group_orders(inputs)
	return tr_landing_shortcuts_mock_group_orders(inputs)
});